define([
	"dojo/_base/declare",
	"csi",
	"csi/table/New"
], function(declare,csi,New) {
	return declare(New, {

		onCreatePopup: function(/*csi.view.Widget*/view) {
			// summary: set value for product type to the parent supplier request and make it read only
			if (this.getParent() && this.getParent().InspirationStyleType != csi.EMPTY_URL) {
				view.addDefaultValue("ProductType", this.getParent().InspirationStyleType);
			}
			this.inherited(arguments);
		},
		
		/**
		 * Retrieve the target Navigation URL when postProcessSuccess() completes
		 *
		 * Overridden from csi/action/NewController.js
		 *
		 * Desired destination on "Save & Go" is to the new Inspiration Style that was created,
		 * default was to go to the SRLineItem that referenced the newly created Style.
		 *
		 * C8-9568
		 *
		 * @return {String} URL of node to navigate to, or null if none
		 */
		_getNavigateNodeURL: function() {
		    return this.getNode().SRLineItemProduct;
		}
	});
});
